import classNames from 'classnames';

import type {PropsWithDisabled} from '@macmillanplatform/ui-core/types';

import {
  ORDERS_DETAILS_URL_PARAMS,
  ORDER_SHIPPING_STATUS_COLORS,
} from '../../../../constants';

import {browserHistory} from '@/shared/utils';

import './index.css';

export interface FilterStatusProps extends PropsWithDisabled {
  id?: string;
  label?: string;
  count?: number;
  isSelected?: boolean;
  shippingStatus?: string[];
}

const FilterStatus = (props: FilterStatusProps) => {
  const {id, label, count, isSelected, shippingStatus, disabled} = props;

  const colorClass = ORDER_SHIPPING_STATUS_COLORS[id] || '';

  const className = classNames('FilterStatus', {
    [`FilterStatus--${colorClass}`]: colorClass,
    'FilterStatus--active': isSelected,
  });

  const handleClick = () => {
    const param = ORDERS_DETAILS_URL_PARAMS.SHIPPING_STATUS;

    const updatedStatuses = isSelected
      ? shippingStatus.filter(status => status !== id)
      : [...new Set([...shippingStatus, id])];

    const value = updatedStatuses.join(',');

    value
      ? browserHistory.setParameter(param, value)
      : browserHistory.deleteParameter(param);

    browserHistory.setParameter(ORDERS_DETAILS_URL_PARAMS.OFFSET, '0');
  };

  return (
    <button
      type="button"
      className={className}
      onClick={handleClick}
      disabled={disabled}
    >
      <i className="fa-solid fa-truck-fast" />
      <span className="FilterStatus__count">{count}</span>
      <span className="FilterStatus__label">{label}</span>
    </button>
  );
};

export default FilterStatus;
